export default __webpack_public_path__ + "static/media/scale-pressed.5213b168.svg";